module.exports = __webpack_public_path__ + "static/img/14000473.6ca8d8f7.png";